window.addEventListener("load", (e) => {
  document.querySelectorAll(".woof_container_inner h4").forEach(function (h) {
    if (h.querySelector("a.woof_front_toggle")) {
      h.style.cursor = "pointer";
      h.addEventListener("click", function (e) {
        h.querySelector("a.woof_front_toggle").click();
        return false;
      });
    }
  });
});
